import { logger } from './logger';

type AnalyticsBrowser = any;

interface AnalyticsService {
  identify: (
    userId: string,
    traits?: Record<string, any>,
    integrations?: Record<string, unknown>
  ) => void;
  track: (event: string, properties?: Record<string, any>) => void;
  // Not being used yet
  // page: (
  //   category?: string,
  //   name?: string,
  //   properties?: Record<string, any>
  // ) => void;
  // group: (groupId: string, traits?: Record<string, any>) => void;
  // alias: (userId: string, previousId?: string) => void;
}

class SegmentAnalyticsService implements AnalyticsService {
  private analytics: AnalyticsBrowser;

  constructor() {
    this.analytics = (window as any).analytics;
    if (!this.analytics) {
      logger.error('Segment analytics not found on window object');
    }
  }

  identify(
    userId: string,
    traits?: Record<string, any>,
    integrations?: Record<string, unknown>
  ): void {
    this.analytics.identify(userId, traits, integrations);
  }

  track(event: string, properties?: Record<string, any>): void {
    this.analytics.track(event, properties);
  }

  page(
    category?: string,
    name?: string,
    properties?: Record<string, any>
  ): void {
    this.analytics.page(category, name, properties);
  }

  group(groupId: string, traits?: Record<string, any>): void {
    this.analytics.group(groupId, traits);
  }

  alias(userId: string, previousId?: string): void {
    this.analytics.alias(userId, previousId);
  }
}

export const analytics: AnalyticsService = new SegmentAnalyticsService();
